import { InputLabel, Space, WithFormControlSelect } from '@procurify/ui'
import { useFormikContext } from 'formik'

import { PriceFormField } from '@webapp/components/PriceField'
import { useProcurifyIntl } from '@webapp/hooks'
import { ExpenseTaxSelect } from '../../ExpenseTaxSelect'
import { isCustomTax } from '../../ExpenseTaxSelect'
import { type ExpenseLineItemFormSchema } from '../ExpenseLineItemForm'
import messages from '../messages'

interface TaxFieldsProps {
  isSubmitting: boolean
}

export const TaxFields = ({ isSubmitting }: TaxFieldsProps) => {
  const intl = useProcurifyIntl()
  const formik = useFormikContext<ExpenseLineItemFormSchema>()
  const isCustomTaxSelected = isCustomTax(formik.values.taxType)

  return (
    <Space align='center' direction='horizontal' justify='end'>
      <Space.Item>
        <InputLabel htmlFor='taxAmount'>
          {intl.formatMessage(messages.taxAmountLabel)}
        </InputLabel>
      </Space.Item>
      <Space.Item width={1 / 3}>
        <PriceFormField
          id='taxAmount'
          name='taxAmount'
          disabled={isSubmitting || isCustomTaxSelected}
          inputProps={{ style: { textAlign: 'right' } }}
        />
      </Space.Item>
      <Space.Item width={1 / 3}>
        <WithFormControlSelect id='taxType' name='taxType'>
          <ExpenseTaxSelect
            inputId='taxType-select'
            value={formik.values.taxType}
            onChange={(opt) => formik.setFieldValue('taxType', opt)}
            isDisabled={isSubmitting}
            menuPortalTarget={document.body}
            menuPlacement='auto'
          />
        </WithFormControlSelect>
      </Space.Item>
    </Space>
  )
}
